import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import superjson from 'superjson';

const pinia = createPinia();

pinia.use(({ store, app }) => {
  store.$route = app.config.globalProperties.$route;
  store.$router = app.config.globalProperties.$router;
  store.$i18n = app.config.globalProperties.$i18n;
});
pinia.use(
  createPersistedState({
    serializer: {
      serialize: superjson.stringify,
      deserialize: superjson.parse,
    },
  }),
);

export default pinia;
